import { useOfferPricing } from 'src/publisher/hooks/use-offer-pricing'

/**
 * @returns dueToday — amount charged now (cents); orderTotal — full order amount (cents)
 */
export const useOrderTotals = () => {
  const {
    selectedOfferPricing,
    physicalBumpOfferPricing,
    digitalBumpOfferPricing,
  } = useOfferPricing()

  const selectedBumpPricing =
    physicalBumpOfferPricing ?? digitalBumpOfferPricing

  const bumpDueToday = selectedBumpPricing?.dueToday ?? 0
  const bumpOrderTotal = selectedBumpPricing?.orderTotal ?? 0

  const orderTotal = (selectedOfferPricing?.orderTotal ?? 0) + bumpOrderTotal
  const dueToday = (selectedOfferPricing?.dueToday ?? 0) + bumpDueToday

  return { dueToday, orderTotal }
}
